import React, { useEffect } from "react";
import { useSession, useSignIn } from "../../../Recoil/Session/Session";
import { fn } from "../../../Functions";


const Logout = () => {

    const { session } = useSession();
    const { logout } = useSignIn();

    console.log(session.email);
    useEffect(()=>{
        (async()=>{
            if ( !session.email ) {
                fn.goto("/");
                return;
            }
            if ( session.email && session.name ) {
                fn.goto('/');
                await logout();
            }
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    return (<div>로그아웃 중...</div>);
}

export default Logout;